// The axios instance every shared manager uses.
//
// The shared repo and each app may resolve their own copy of axios (two
// node_modules). Defaults (baseURL) and interceptors only take effect on the
// instance the managers actually call, so an app that needs to add a request
// interceptor takes it from here rather than from its own `require('axios')`.
module.exports = require('axios');
